// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICountryResponseDto
 */
export interface ICountryResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ICountryResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICountryResponseDto
     */
    alpha2?: string;
    /**
     * 
     * @type {string}
     * @memberof ICountryResponseDto
     */
    alpha3?: string;
    /**
     * 
     * @type {string}
     * @memberof ICountryResponseDto
     */
    us_postal?: string;
    /**
     * 
     * @type {string}
     * @memberof ICountryResponseDto
     */
    name?: string;
}

/**
 * Check if a given object implements the ICountryResponseDto interface.
 */
export function instanceOfICountryResponseDto(value: object): value is ICountryResponseDto {
    return true;
}

export function ICountryResponseDtoFromJSON(json: any): ICountryResponseDto {
    return ICountryResponseDtoFromJSONTyped(json, false);
}

export function ICountryResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICountryResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'alpha2': json['alpha2'] == null ? undefined : json['alpha2'],
        'alpha3': json['alpha3'] == null ? undefined : json['alpha3'],
        'us_postal': json['us_postal'] == null ? undefined : json['us_postal'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function ICountryResponseDtoToJSON(json: any): ICountryResponseDto {
    return ICountryResponseDtoToJSONTyped(json, false);
}

export function ICountryResponseDtoToJSONTyped(value?: ICountryResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'alpha2': value['alpha2'],
        'alpha3': value['alpha3'],
        'us_postal': value['us_postal'],
        'name': value['name'],
    };
}

